export enum GetWorkflowExecutionExtendsOptions {
  TEMPLATE_VERSION = 'templateVersion',
}

export enum GetWorkflowTemplateListExtendsOptions {
  ACTIVE_VERSION = 'ACTIVE_VERSION',
  VERSIONS = 'VERSIONS',
}
